import { create } from 'zustand'

interface AnalyticsActiveStore {
  /** `ampli` is loaded and un-muted. */
  webActive: boolean
  /** `ampliDigital` is loaded and un-muted. */
  digitalActive: boolean
  setActive: (active: { webActive: boolean; digitalActive: boolean }) => void
}

// Lets consumers avoid sending properties to a muted Amplitude client.
export const useAnalyticsActiveStore = create<AnalyticsActiveStore>((set) => ({
  webActive: false,
  digitalActive: false,
  setActive: (active) => set(active),
}))
